<template>
  <v-layout row>
    <v-flex xs12 sm12>
      <v-card class="elavation-1 transparent">
        <v-toolbar class="transparent" flat height="37">
          <v-btn icon dark title="Back to previous page" @click="$router.go(-1)">
            <v-icon>arrow_back</v-icon>
          </v-btn>
          <v-spacer></v-spacer>
          <help-link appId="company" pageId="teams" color="white"></help-link>
          <v-btn v-if="hasEditRights" fab dark small color="primary" title="Add New Team" @click="showAddTeam">
            <v-icon dark>add</v-icon>
          </v-btn>
        </v-toolbar>
        <v-progress-linear v-if="loading" indeterminate color="primary" height="3" style="margin:1px -3px 0px -3px;"></v-progress-linear>
      </v-card>

      <v-layout row wrap style="padding-top:5px;padding-bottom:10px;">          
          <v-flex xs12> 
            <p v-if="error" style="color:red;">{{ errorMessage }}</p>
            <div v-for="(item, index) in filtered_teams" :key="index" style="padding:5px 0 10px 0;"> 
              <v-card class="elavation-1 transparent">
                <v-toolbar flat height="35px">
                    <span class="font-weight-bold ">{{ item.name }}</span>
                    <span style="padding-left:15px;" v-if="loggedInTeamId==item.teamId">(My Team)</span>
                    <v-spacer></v-spacer>
                    <v-btn icon title="Edit Team Details" v-if="hasEditRights" @click="editTeam(item)">
                        <v-icon small>edit</v-icon>
                    </v-btn>
                </v-toolbar>
                <v-layout row wrap>
                    <v-flex xs12 style="padding:20px;">
                        <div class="text-xs-left" style="padding-left:10px;"> {{item.description}} </div>
                        <v-layout row wrap style="margin:10px 0px 10px 0px;">
                          <div v-for="(item2,index2) in getTeamMembersByTeam(item.teamId)" :key="index2">
                            <v-chip @click="viewUserProfile(item2)">
                              <v-avatar>
                                <v-img ref="avatar" :src="common.getAvatarUrl(item2.userId)"></v-img>
                              </v-avatar>
                              {{item2.firstName}} {{item2.lastName}}
                              <!-- <div v-if="item2.role=='Executive'">&nbsp;<v-icon small color="primary">fas fa-user-shield</v-icon></div>
                              <div v-if="item2.role=='Admin'">&nbsp;<v-icon color="primary">admin_panel_settings</v-icon></div>
                              <div v-if="item2.role=='Supervisor'">&nbsp;<v-icon color="primary">supervisor_account</v-icon></div> -->
                            </v-chip>
                          </div>
                      </v-layout>
                    </v-flex>                  
                </v-layout>
              </v-card>
            </div>
          </v-flex>
      </v-layout>
    </v-flex>

    <v-dialog v-model="dialogAdd" persistent width="500" > 
      <add-edit-team ref="addEditTeamRef" :dialogAdd.sync="dialogAdd" @send="getTeams(false)"></add-edit-team>
    </v-dialog>
  </v-layout>  
</template>
<script>

import teamApi from '@/api/team'
import common from '@/common/functions' //for refactor
import { hasEditRights } from '@/helpers/access-permissions'

export default {    
    name: 'Teams',
    metaInfo: {
        title: 'Teams',
        meta: [
            { charset: 'utf-8' },
            { name: 'description', content: 'View list of company teams, all members for each teams and their roles' },
            { name: 'viewport', content: 'width=device-width, initial-scale=1' }
            ]
    }, 
    components: {
      'help-link': () => import('@/components/Common/HelpLink'),
      'add-edit-team' : () => import('@/components/Team/AddEditTeam')
    },   
    data () {
      return {
        common,
        teams: [],
        filtered_teams: [],
        team_members: [],
        error: false,
        errorMessage: '',
        loading: false,
        dialogAdd: false,
      }
    },
    methods: {      
      editTeam(data) {
        this.$refs.addEditTeamRef.setEditParams(data)
        this.dialogAdd=true
      },
      viewUserProfile(data) {
        if (this.loggedInuserId == data.userId) this.$router.push('/myprofile')
        else this.$router.push(`/hr/employees/${data.userId}`)
      },
      showAddTeam() {
        this.$refs.addEditTeamRef.setAddParams()
        this.dialogAdd=true
      },
      async getTeams(show_loading) {
        try {
          this.loading = show_loading
          const response = await teamApi.getTeamsByCompany(true)
          if (response && response.status == 200) {
            this.teams = response.data.items
            this.filtered_teams = response.data.items
            this.team_members = response.data.membersItems
          }
          this.loading = false
        }catch(error){
          this.error = true
          this.errorMessage = error
        }
      },
      getTeamMembersByTeam(teamId) {         
        return this.team_members.filter(item => {
          return item.teamId == teamId
        })
      }
    },
    created() {
      //update header titles
      this.$root.$emit('setHeaderTitles', {
          display: true,
          headerTitle: '',
          headerPageTitle: 'Company Teams'
      })
      this.getTeams(true)
    },
    computed: {
      hasEditRights() {
          return hasEditRights(this.$router.currentRoute.path)
      },
      loggedInTeamId() {
        return this.$store.state.teamId
      },
      loggedInuserId() {
        return this.$store.state.userId
      },
    }
  }
</script>